module.exports = __webpack_public_path__ + "img/digifinex.6d7b5428.svg";